<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：菜品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('上架中')" name="sell"></el-tab-pane>
        <el-tab-pane :label="$t('下架中')" name="lower">
          <span slot="label">{{ $t('下架中') }} <el-tag size="mini">{{ product_count.lower }}</el-tag></span>
        </el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!--        <el-form-item :label="$t('菜品分类')">-->
        <!--          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">-->
        <!--            <el-option :label="$t('全部')" value="0"></el-option>-->
        <!--            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item :label="$t('菜品名称')"><el-input size="small" v-model="searchForm.product_name"
            :placeholder="$t('请输入菜品名称')"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">{{ $t('查询') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加菜品-->
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus"
        v-auth="'/product/store/product/add'" @click="addClick">{{ $t('添加菜品') }}</el-button></div>
    <!--内容-->
    <div class="container-box">
      <div class="left">
        <ul>
          <li class="left-tab" @click="selectCategory('全部', 0)" :class="{ 'selected': selectedTab === '全部' }">{{ $t('全部') }}
          </li>
          <li class="left-tab" v-for="(item, index) in categoryList" :key="index"
            :class="{ 'selected': selectedTab === item.name }" @click="selectCategory(item.name, item.category_id)">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="product-content">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"
              @sort-change="sortChange">
              <el-table-column prop="product_name" :label="$t('菜品')" width="400px">
                <template slot-scope="scope">
                  <div class="product-info">
                    <div class="pic"><img v-img-url="scope.row.image[0].file_path" alt="" /></div>
                    <div class="info">
                      <div class="name">{{ scope.row.product_name }}</div>
                      <div class="price">{{ $t('销售价') }}：{{ scope.row.product_price }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!--              <el-table-column prop="category.name" :label="$t('分类')"></el-table-column>-->
              <el-table-column prop="sales_actual" :label="$t('实际销量')"></el-table-column>
              <el-table-column prop="product_stock" :label="$t('库存')" sortable></el-table-column>
              <el-table-column prop="product_status.text" :label="$t('状态')">
                <template slot-scope="scope">
                  <span
                    :class="{ green: scope.row.product_status.value == 10, gray: scope.row.product_status.value == 20 }">
                    {{ $t(scope.row.product_status.text) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="create_time" :label="$t('发布时间')"></el-table-column>
              <el-table-column prop="product_sort" :label="$t('排序')"></el-table-column>
              <el-table-column prop="lang" :label="$t('多语言翻译')" align="center" width="90px">
                <template slot-scope="scope">
                  <span class="lang-check"
                    :class="[checkLanguage(scope.row.lang) ? 'el-icon-check' : 'el-icon-close']"></span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :label="$t('操作')" width="160">
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.row)" type="text" size="small"
                    v-auth="'/product/store/product/edit'">{{ $t('编辑') }}</el-button>
                  <el-button @click="undercarriage(scope.row, 20)" type="text" size="small"
                    v-auth="'/product/store/product/state'"
                    v-if="scope.row.product_status.value != 20">{{ $t('下架') }}</el-button>
                  <el-button @click="undercarriage(scope.row, 10)" type="text" size="small"
                    v-auth="'/product/store/product/state'" v-else>{{ $t('上架') }}</el-button>
                  <el-button @click="deleteClick(scope.row)" type="text" size="small"
                    v-auth="'/product/store/product/delete'">{{ $t('删除') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
            :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import { checkLanguage } from '@/utils/base.js'
export default {
  components: {},
  data() {
    return {
      selectedTab: '全部',
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: '',
        category_id: '',
        sortType: 'all',
        sortOrder: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      /*菜品统计*/
      product_count: {},
      languageFields : {
        "en": "english",
        "it": "italian",
        "de": "german",
        "es": "spanish",
        "fr": "french",
        "hr": "croatia",
        "sl": "slovenia",
        "hu": "hungarian"
      },
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    selectCategory(name, id) {
      localStorage.setItem("addProductCategoryid", id)
      this.selectedTab = name;
      if (name == '全部') {
        this.searchForm.category_id = ''
      } else {
        this.searchForm.category_id = id
      }
      this.curPage = 1;
      this.getData();
    },
    // 多语言判断
    checkLanguage(lang) {
      return checkLanguage(lang)
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    // 排序change
    sortChange({ column, prop, order }) {
      if (prop === 'product_stock') {
        // ascending:升序,dscending:降序
        this.searchForm.sortOrder = order ? order === 'ascending' ? 'asc' : 'desc' : ''
        this.searchForm.sortType = order ? 'product_stock' : 'all'
        this.getData()
      }
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      const langSelect = localStorage.getItem('lang-select');
      PorductApi.storeProductList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          // 解析并更新菜品名称
          self.tableData.forEach(item => {
            if (item.lang) {
              const langInfo = JSON.parse(item.lang.product_info);
              const langField = this.languageFields[langSelect];
              if (langInfo[langField] && langInfo[langField].product_name) {
                item.product_name = langInfo[langField].product_name;
              }
            }
          });
          self.categoryList = data.data.category;
          self.categoryList.forEach(item => {
            if (item.lang) {
              const langInfo = JSON.parse(item.lang.category);
              const langField = this.languageFields[langSelect];
              if (langInfo[langField]) {
                item.name = langInfo[langField];
              }
            }
          });
          self.totalDataNumber = data.data.list.total;
          self.product_count = data.data.product_count;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.searchForm.category_id = ''
      this.curPage = 1;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/product/store/product/add');
    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/product/store/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'edit'
        }
      });
    },
    /* 强制下架上架*/
    undercarriage(row, state) {
      let self = this;
      let war = "";
      let war_ = '';
      if (state == 20) {
        war = self.$t("强制下架")
        war_ = self.$t('下架')
      } else if (state == 10) {
        war = self.$t("重新上架")
        war_ = self.$t('上架')
      }
      self
        .$confirm(self.$t("确认要") + war + "?", self.$t('提示'), {
          type: 'warning'
        })
        .then(() => {
          PorductApi.storeStateProduct({
            product_id: row.product_id,
            state
          }).then(data => {
            self.$message({
              message: war_ + self.$t('成功'),
              type: 'success'
            });
            self.getData();
          });
        });
    },
    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'copy'
        }
      });
    },

    /*删除*/
    deleteClick: function (row) {
      let self = this;
      self
        .$confirm(self.$t('删除后不可恢复，确认删除该记录吗?'), self.$t('提示'), {
          type: 'warning'
        })
        .then(() => {
          PorductApi.storeDelProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: self.$t('删除成功'),
              type: 'success'
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
.container-box {
  width: 100%;
  display: flex;
}

.left {
  flex: 1 0 auto;
  min-width: 10%;
  height: 600px;
  vertical-align: top;
  overflow: auto;
}

.left .left-tab {
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-bottom: 1px solid #C0C4CC;
}

.left .left-tab:not(.selected):hover {
  background-color: #ebeef5;
  cursor: pointer;
}

.left .selected {
  background-color: #66b1ff;
  border-bottom: 1px solid #66b1ff;
  color: #fff;
}

.right {
  flex: 2 0 auto;
  vertical-align: top;
}</style>



// WEBPACK FOOTER //
// src/views/product/store/product/index.vue